<template>
  <v-container>
    <v-row>
      <v-col cols="2">
        <v-icon>mdi-arrow-left-bold</v-icon>
      </v-col>

      <v-col cols="10">
        <v-menu
          v-model="menu1"
          :close-on-content-click="true"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="280px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field v-model="startDate" label prepend-icon="mdi-calendar" readonly v-on="on"></v-text-field>
          </template>
          <v-date-picker v-model="startDate" @input="menu1 = false"></v-date-picker>
        </v-menu>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="2">
        <v-icon>mdi-arrow-right-bold</v-icon>
      </v-col>

      <v-col cols="10">
        <v-menu
          v-model="menu2"
          :close-on-content-click="true"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="280px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field v-model="endDate" label prepend-icon="mdi-calendar" readonly v-on="on"></v-text-field>
          </template>
          <v-date-picker v-model="endDate" :min="minEndDate" @input="menu2 = false"></v-date-picker>
        </v-menu>
      </v-col>
    </v-row>
  </v-container>
</template>
 
<script lang="ts">
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { DateTime } from "luxon";

@Component({
  components: {},
})
export default class DateSelection extends Vue {
  @Prop() public msg!: string;

  private menu1: any = false;
  private menu2: any = false;
  private startDate: string = DateTime.now().setZone('utc').toUTC().minus({months:1}).toISO().substr(0, 10);
  private endDate: string = DateTime.now().setZone('utc').toUTC().toISO().substr(0, 10);
  private minEndDate: string = '';

  @Watch('startDate')
  protected onStartDateChanged(newDate: string, oldDate: string): any {
    this.minEndDate = DateTime.fromFormat(newDate, 'yyyy-MM-dd').toISO().substr(0, 10);
    // this.$store.dispatch('setStartDate', newDate);
    this.$emit('setStartDate', newDate);
  }

  @Watch('endDate')
  protected onEndDateChanged(newDate: string, oldSDate: string): any {

    // Dont allow going below minimum
    if (DateTime.fromFormat(newDate, 'yyyy-MM-dd') < DateTime.fromFormat(this.minEndDate, 'yyyy-MM-dd')) {
       newDate = this.minEndDate;
    }

    //this.$store.dispatch('setEndDate', newDate);
    this.$emit('setEndDate', newDate);
  }


  // private changeSubarea(old_selected_subarea: number, event: any) {
  //   this.selected_subarea = parseInt(event.target.value, 10);
  // }

  //

  private mounted() {
    // this.$store.dispatch('setStartDate', this.startDate);
    // this.$store.dispatch('setEndDate', this.endDate);

    this.$emit('setStartDate', this.startDate);
    this.$emit('setEndDate', this.endDate);

    // this.$store.watch(
    //   (state) => {
    //     return this.$store.state.startDate; // Does not seem to work with Getter
    //   },
    //   (newValue, oldValue) => {

    //     this.startDate = newValue;
    //     // console.log(oldValue);
    //     // console.log(newValue);
    //   },
    //     // Optional Deep if you need it
    //     {
    //       deep: true,
    //     },
    // );

    // this.$store.watch(
    //   (state) => {
    //     return this.$store.state.endDate;
    //   },
    //   (newValue, oldValue) => {

    //     this.endDate = newValue;
    //   },
    // );

    return;
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
